<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      南油站<br>
站点介绍<br>
南油站位于深圳市南山区南海大道与登良路交叉口，车站周边规划以商业、办公为主体。 车站为地下二侧式站台平行换乘车站，其中地下一层为9、12号线共用站厅层，地下二层为9、12号线侧式平行换乘站台层。车站共设有7个出入口，其中C1、C2、D出入口连接物业区。车站设有母婴室、自动扶梯、垂梯、公共洗手间等便民设施。 车站以米白色为主调，搭配湖蓝色立柱，以服饰艺术中的“环形飘带”为灵感，在重点区域采用层叠、递进的手法体现“环环相扣”设计，结合其他区域方形分割的空间设计，形成方圆之间，别具一格的时尚气息。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:21	00:00	9号线	3分50秒	5分55秒<br>
文锦	06:29	23:09	9号线	3分50秒	5分55秒<br>
左炮台东	06:14	23:10	12号线	4分钟	8分钟<br>
海上田园东	06:37	00:01	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:22	00:00	9号线	4分25秒	5分55秒<br>
文锦	06:29	23:09	9号线	4分25秒	5分55秒<br>
左炮台东	06:18	23:10	12号线	8分钟	8分钟<br>
海上田园东	06:39	00:01	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:21	01:00	9号线	4分钟	5分55秒<br>
文锦	06:29	00:09	9号线	4分钟	5分55秒<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
南海大道东侧（南）、深圳恒大天璟<br><br>
B出入口:<br>
登良路南侧<br><br>
E出入口:<br>
登良路北侧、百富大厦、恒裕中心、公园道大厦、深圳来福士广场<br><br>
F1出入口:<br>
南海大道西侧（南）、粤海路、金晖大厦、深圳动漫园、新保辉大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 南油地铁站①<br>
226、M242、M506、M105、70、113、204、M106、M133、M467、M527<br><br>
F1出入口:<br>
公交站名： 南油地铁站①<br>
226、M106、M242、M448、M527、M506、M105、204、70、113、 M133、M467<br><br>
E出入口:<br>
公交站名： 南油地铁站②<br>
70、113、M133、M467、204、226、M506、M105、M106、M242、M448、M527<br><br>
B出入口:<br>
公交站名： 南油地铁站②<br>
70、113、M467、M527、204、226、M105、M106、M242、M506<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>